module.exports = __webpack_public_path__ + "img/icon-star-regular.8eaa146f.png";